import params from "./params.json";

export function Params(lang = null) {
  if (lang === null) {
    return params.default;
  }

  return params[lang] || params.ru;
}
